import { render, staticRenderFns } from "./shareholders-item.vue?vue&type=template&id=3f6302a9&scoped=true"
import script from "./shareholders-item.vue?vue&type=script&lang=js"
export * from "./shareholders-item.vue?vue&type=script&lang=js"
import style0 from "./shareholders-item.vue?vue&type=style&index=0&id=3f6302a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6302a9",
  null
  
)

export default component.exports